import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  templates: [],
  template: {},
});

export const mutations = {
  SET_TEMPLATES(state, payload) {
    state.templates = payload || [];
  },
  SET_TEMPLATE(state, payload) {
    state.template = payload || {};
  },
};

export const actions = {
  // studyYear / kurs are the page's O'quv yili and Kurs filters; "" leaves a filter off, and
  // kurs "default" asks for the templates with no kurs (the ones shown as "Barcha kurslar").
  async INIT_TEMPLATES({ commit }, options = {}) {
    const { page = 1, itemsPerPage = 20, search = "", studyYear = "", kurs = "" } = options;
    const p = Number(page - 1) || 0;
    let url = `admin/templates?page=${p}&size=${itemsPerPage}&search=${encodeURIComponent(search)}`;
    if (studyYear) url += `&study_year=${encodeURIComponent(studyYear)}`;
    if (kurs) url += `&kurs=${encodeURIComponent(kurs)}`;
    const data = await vm.$axios.$get(url);
    if (data) {
      commit("SET_TEMPLATES", data.content);
      return data.totalElements;
    }
    return 0;
  },

  async UPLOAD_TEMPLATE(ctx, formData) {
    return await vm.$axios.$post("admin/templates/upload", formData);
  },

  // id-based: a code may now have several (kurs, study_year) variants, so edit/delete
  // target a specific row by id rather than by the (no longer unique) code.
  async UPDATE_TEMPLATE(ctx, { id, formData }) {
    return await vm.$axios.$put(`admin/templates/id/${id}`, formData);
  },

  async DELETE_TEMPLATE(ctx, id) {
    return await vm.$axios.$delete(`admin/templates/id/${id}`);
  },
};

export const getters = {
  GET_TEMPLATES: (state) => state.templates,
  GET_TEMPLATE: (state) => state.template,
};
